import { gql } from '@lichtblick/apollo';

export const UPLOAD_WORK_ORDER_DOCUMENTS = gql`
  mutation UploadWorkOrderDocuments_V1($input: UploadWorkOrderDocumentsInput!) {
    uploadWorkOrderDocuments_V1(input: $input) {
      error
      data {
        id
        uri
        fileName
        mimeType
        fileSize
        isSafe
        virusScanResult
      }
    }
  }
`;
